import React, { Component } from 'react';
import { PUBLIC_API_BASE_ENDPOINT } from 'configs/AppConfig';
import service from 'auth/FetchInterceptor'

class AboutUs extends Component {

	constructor(props) {
        super(props);

		this.state = {
			content: ''
		}
	}

	componentDidMount(){
        this.fetchPage();
    }

	fetchPage = async () => {

		const config = {
			headers:{
				'public-request': 'true',
				'Content-Type': 'application/json'
			}
		};

		await service.get(PUBLIC_API_BASE_ENDPOINT + 'page/about', config).then((response) => {            
			this.setState({
				content: response.content,             
			});        
		});
	}

	render(){
		return (
								
			<div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
				
				<div className="container-fluid m-5">
					<div dangerouslySetInnerHTML={{ __html: this.state.content }} />	
				</div>
				
			</div>
		
		)
	}
	
}

export default AboutUs
